// 用户注册
<template>
  <div>
    <div>
      <el-row type="flex" justify="start" class="login-header">

        <div id="logo-div">
          <el-link :underline="false" href="/"><img src="../../assets/admin/logo.jpg"></el-link>
        </div>


        <div id="logo-title">欢迎注册</div>

      </el-row>
    </div>
    <div style="background-color: #FAFAFA">
      <el-row type="flex" justify="space-around" align="middle">
        <div><img src="../../assets/admin/login_bg.jpg"></div>
        <div class="login-form">
          <el-row class="bottom-margin">
            <!-- <div id="login-title">
              <div>
                <span>企业注册</span>
              </div>
            </div> -->
			<div style="padding-bottom:20px;display: none;">
				<el-radio v-model="userType" label="00">企业</el-radio>
				<el-radio v-model="userType" label="01">个人</el-radio>
			</div>
          </el-row>
          <el-row>
			  <el-image :src="loginPtCode" v-show="userType=='01'"></el-image>
            <el-form label-position="left" :model="ruleForm" status-icon :rules="rules" ref="ruleForm"
                     label-width="100px" :hide-required-asterisk="true"
                     class="demo-ruleForm" v-show="userType=='00'">
              <el-form-item label="公司名称：" prop="companyName">
                <el-input type="text" v-model="ruleForm.companyName"></el-input>
              </el-form-item>
              <el-form-item label="手机号码：" prop="phonenumber">
                <el-input type="text" v-model="ruleForm.phonenumber"></el-input>
              </el-form-item>
              <el-form-item label="密码：" prop="password">
                <el-input type="password" v-model="ruleForm.password" show-password></el-input>
              </el-form-item>
              <el-form-item label="确认密码：" prop="rePassword">
                <el-input type="password" v-model="ruleForm.rePassword" show-password></el-input>
              </el-form-item>
              <!-- <el-form-item label="验证码：">
                <el-col :span="12">
                  <el-input v-model="ruleForm.validateCode"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-image :src="captchaImageUrl" @click="refreshCaptchaImage" style="height: 40px" fit="scale-down"/>
                </el-col>
              </el-form-item> -->
			  <Verify
			    @success="smsCheckSuccess"
			    :mode="'pop'"
			    :captchaType="'blockPuzzle'"
			    :imgSize="{ width: '330px', height: '155px' }"
			    ref="smsCheckVerify"
			  ></Verify>
			  <Verify
			    @success="registerCheckSuccess"
			    :mode="'pop'"
			    :captchaType="'blockPuzzle'"
			    :imgSize="{ width: '330px', height: '155px' }"
			    ref="registerCheckVerify"
			  ></Verify>
			  
              <el-form-item label="手机验证码：">
                <el-col :span="12">
                  <el-input v-model="ruleForm.validateSmsCode"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-button round v-show="sendAuthCode" @click="getAuthCodeVerify()">获取验证码</el-button>
                  <el-button round v-show="!sendAuthCode">{{auth_time}} s</el-button>
                </el-col>
              </el-form-item>
			  <el-form-item label="邀请码：" prop="invitationCode" v-show="false">
			    <el-input type="text" v-model="ruleForm.invitationCode"></el-input>
			  </el-form-item>
              <el-button id="login-btn" class="bottom-margin full-width" type="primary" @click="getRegisterVerify()"
                         :loading="registering">
                注&nbsp;&nbsp;&nbsp;&nbsp;册
              </el-button>
            </el-form>
          </el-row>
          <el-row type="flex" justify="space-between">
            <span id="justify-span" class="font-small">
              <span>已有账号？</span>
              <el-link type="primary"   @click.native="navToLogin">立即登录</el-link>
            </span>
          </el-row>
        </div>
      </el-row>
    </div>
    <div id="login-footer">
      版权所有 泰盈科技集团股份有限公司 ©2022 网站备案号：<a target="_blank" href="https://beian.miit.gov.cn/">鲁ICP备16023615号-3</a>
    </div>
  </div>
</template>

<script>
	
  import Verify from "@/components/Verifition/Verify";
  import { encrypt } from "@/util/jsencrypt";
	
  export default {
	components: { Verify },
    data() {

      var validateRePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
	  
	  var validatePassword = (rule, value, callback) => {
		const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/;
		// const regRepeat = /([a-zA-Z0-9])\\1{1,}/;
	    if (value === '') {
	      callback(new Error('请输入密码'));
	    }else if (!(reg.test(value))) {
		  callback(new Error('密码长度介于8和20之间,且包含大小写字母、数字和特殊字符'));
		}else{
		  var ifLx = false;
		  var arr = value.split('');
		  for (var i = 1; i < arr.length-1; i++) {
			  if(arr[i+1].charCodeAt() - arr[i].charCodeAt() == 1 || arr[i+1].charCodeAt() == arr[i].charCodeAt()){
				  ifLx = true;
				  break;				  
			  }
		  }
		  if(ifLx){
			  callback(new Error('密码中不能出现重复或连续的字符'));
		  }else{
			  callback();
		  }
	    }
	  };

      var validatephonenumber = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入手机号码'));
        } else {
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
          //console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号码'));
          }
        }
      };

      return {
        captchaImageUrl: '/api/captcha/captchaImage?type=char',
        sendAuthCode: true,/*布尔值，通过v-show控制显示‘获取按钮'还是‘倒计时' */
        auth_time: 0, /*倒计时 计数器*/
        verification: "",//绑定输入验证码框框
        registering: false,
		loginPtCode: require("../../assets/admin/login_pt_code.png"),
        ruleForm: {
          userName: '',
          companyName: '',
          password: '',
          rePassword: '',
          phonenumber: '',
          // validateCode: '',
          validateSmsCode: '',
		  invitationCode:''
        },
        rules: {
          userName: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
          ],
          companyName: [
            {required: (this.userType=='00'), message: '请输入公司名称', trigger: 'blur'},
          ],
          password: [
            {required: true, trigger: 'blur', validator: validatePassword},
          ],
          rePassword: [
            {validator: validateRePassword, trigger: 'blur'},
          ],
          phonenumber: [
            {validator: validatephonenumber, trigger: 'blur'},
          ]
        },
		userType:'00'
      }
    },
    mounted() {
    },
    created() {
    },
    computed: {},
    methods: {
      // 刷新验证码图片
      // refreshCaptchaImage() {
      //   this.captchaImageUrl = '/api/captcha/captchaImage?type=char&s=' + Math.random()
      // },
	  
	  getRegisterVerify(){
	  	this.$refs['ruleForm'].validate((valid) => {
	  		if (valid) {
	  			this.$refs.registerCheckVerify.show();		  
	  		} else {
	  		    console.log('error register!!')
	  		    return false;
	  		}
	  		})
	  },
      registerCheckSuccess(params) {
		
		this.ruleForm.code = params.captchaVerification;
		  
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.$store.dispatch("register", {
              loginName: this.ruleForm.phonenumber,
              userName: (this.userType=='00'?this.ruleForm.companyName:this.ruleForm.phonenumber),
              password: encrypt(this.ruleForm.password),
              phonenumber: this.ruleForm.phonenumber,
              role: (this.userType=='00'?5:2),   //角色: 5接包企业2普通角色
              roleIds: (this.userType=='00'?5:2),
              // validateCode: this.ruleForm.validateCode,
			  __captchaVerification: this.ruleForm.code,
              validateSmsCode: this.ruleForm.validateSmsCode,
			userType:this.userType,
			invitationCode:this.ruleForm.invitationCode
            }).then(() => {
              this.registering = true;
              this.$message.success('注册成功');
              this.$router.push("/login");
            }).catch(err => {
              this.$message.error(err.msg)
            })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
	  
	  getAuthCodeVerify() {
	     this.$refs['ruleForm'].validate((valid) => {
	       if (valid) {
	  			  this.$refs.smsCheckVerify.show();
	  			  
	       } else {
	         console.log('error get auth code!!')
	         return false;
	       }
	     })
	  },
	  
      //发送短信验证
      smsCheckSuccess(params) {
        // if (this.ruleForm.phonenumber == '') {
        //   this.$message.error('请输入手机号码');
        //   return false;
        // }
        // if (this.ruleForm.validateCode == '') {
        //   this.$message.error('请输入验证码');
        //   return false;
        // }
		this.ruleForm.code = params.captchaVerification;

        const verification = this.ruleForm.phonenumber;
        this.$store.dispatch("smsSend", {
          mobile: this.ruleForm.phonenumber,
          code: this.ruleForm.code
        }).then(() => {
          this.$message.success('验证码发送成功');
          this.sendAuthCode = false;
          //设置倒计时秒
          this.auth_time = 60;
          var auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendAuthCode = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        }).catch(err => {
          // this.refreshCaptchaImage();
          this.$message.error(err.msg)
        })

      },
	navToLogin(){
		this.$router.push("/login")
	}
    }
  }
</script>

<style scoped>
  @import "../../assets/css/common.css";
  @import "../../assets/css/login.css";

  .login-form {
    margin-top: 20px;
  }

  .el-form-item {
    margin-bottom: 17px;
  }
</style>